import React from 'react';

export function FacebookIcon({ size = 20, ...props }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size} {...props}>
            <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.91h-2.33V22c4.78-.79 8.44-4.94 8.44-9.94z" />
        </svg>
    );
}

export function InstagramIcon({ size = 20, ...props }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width={size} height={size} {...props}>
            <rect x="2" y="2" width="20" height="20" rx="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
        </svg>
    );
}

export function LinkedinIcon({ size = 20, ...props }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size} {...props}>
            <path d="M4.98 3.5C3.34 3.5 2 4.84 2 6.48c0 1.63 1.34 2.97 2.98 2.97h.03c1.65 0 2.98-1.34 2.98-2.97C7.99 4.84 6.66 3.5 4.98 3.5zM2.4 21.5h5.15V9.16H2.4V21.5zM9.9 9.16h4.94v1.69h.07c.69-1.3 2.37-2.67 4.87-2.67 5.21 0 6.17 3.43 6.17 7.89v7.43h-5.15v-6.59c0-1.57-.03-3.6-2.19-3.6-2.19 0-2.53 1.71-2.53 3.48v6.71H9.9V9.16z" />
        </svg>
    );
}

export function WhatsappIcon({ size = 24, ...props }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size} {...props}>
            <path d="M17.47 14.38c-.29-.15-1.72-.85-1.99-.94-.27-.1-.46-.15-.66.15-.2.29-.76.94-.93 1.13-.17.2-.34.22-.63.08-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.08-.15-.66-1.6-.91-2.19-.24-.58-.48-.5-.66-.51-.17-.01-.37-.01-.56-.01-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44s1.05 2.83 1.19 3.03c.15.2 2.06 3.14 4.99 4.41.7.3 1.24.48 1.67.61.7.22 1.34.19 1.84.12.56-.08 1.72-.7 1.97-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.2-.56-.34z" />
            <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.87.52 3.63 1.42 5.13L2 22l5.13-1.5a9.87 9.87 0 0 0 4.91 1.31h.01c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm0 18.02h-.01a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3.05.89.9-2.98-.19-.31a8.11 8.11 0 0 1-1.24-4.4c0-4.49 3.66-8.14 8.15-8.14 2.17 0 4.21.85 5.75 2.39a8.08 8.08 0 0 1 2.38 5.76c0 4.49-3.66 8.1-8.26 8.1z" />
        </svg>
    );
}
